import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {UserCancelDto} from "admin-api-dto";
import {map} from "rxjs";
import {environment} from "../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class UserCancelDataService {

  constructor(private readonly http: HttpClient) {}

  public getCancelDate() {
    return this.http.get<UserCancelDto[]>(`${environment.apiUrl}/api/private/cancel-data`).pipe(
      map((cancelData: UserCancelDto[]) => {
        return cancelData.sort((a, b) => new Date(b.cancelDate).getTime() - new Date(a.cancelDate).getTime());
      })

    )
  }

}
